<script setup lang="ts">
import { t } from '@/locales/i18n'
import type { TUiTypeValues } from '../../../types/api/reports'

defineProps<{
  position: TUiTypeValues['player_position'] | TUiTypeValues['opponent_position']
}>()
</script>

<template>
  <div class="truncate">
    {{ t(`players.${position}`) }}
  </div>
</template>
